var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('finance-bar',{attrs:{"flag":_vm.flag,"related-plan-list":_vm.relatedPlanList},on:{"compare":function () {
                _vm.flag = !_vm.flag;
            },"start-calculate":_vm.startCalculate,"export-to-file":_vm.exportToFile,"change":_vm.getRelatedCalculateData}}),_c('finance-container',{attrs:{"data":_vm.financialAppraisalData,"related-data":_vm.relatedData,"flag":_vm.flag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }